import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

import Success from '@/assets/svgs/success.svg?react';
import Error from '@/assets/svgs/error.svg?react';
import { useResponsive } from '@/utils/useResponsive';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const { isMobile } = useResponsive();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group ![--width:450px]"
      position='bottom-center'
      visibleToasts={1}
      offset={0}
      icons={{
        success: <Success />,
        error: <Error />,
      }}
      toastOptions={{
        style: {
          borderBottomRightRadius: isMobile ? 8 : 0,
          borderBottomLeftRadius: isMobile ? 8 : 0,
          backgroundColor: '#323232',
          color: 'white',
          height: '56px',
        },
        classNames: {
          content: 'ml-[18px] text-labelSmall',
        },
        actionButtonStyle: {
          backgroundColor: 'transparent',
          stroke: 'white',
          paddingRight: 0,
        }
      }}
      {...props}
    />
  );
};

export { Toaster };
